<template>
  <ChatItem class="chat__message" :first="first" :last="last">
    <RawHtml :html="content.message" />
  </ChatItem>
</template>

<script>
import { RawHtml } from '@/components/global'
import { ContentPropMixin } from '@/mixins'

import ChatItem from './ChatItem.vue'
import ChatItemPropsMixins from './ChatItemPropsMixins.js'

export default {
  name: 'ChatMessage',
  mixins: [ChatItemPropsMixins, ContentPropMixin],
  components: { ChatItem, RawHtml },
}
</script>
